export default class Gallery {

	static getHolderSelectors = () => ['.gallery-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		GLightbox({
			touchNavigation: true,
			loop: false,
			autoplayVideos: false
		});
	}

}
